import React, { Component, useEffect } from "react";
import * as API from "../lib/apis";
import Loader from "components/Loader";
import { appendScript, encodingBase64 } from "../lib/utils";
import { useLocalStorage } from "../lib/useLocalStorage";
import { STORAGE_KEY, SERVICE_CODE } from "../constants";

const queryString = require("query-string");

// class Owp extends Component {
//   state = {
//     ping: "",
//   };

//   constructor(props) {
//     super(props);
//     this.queryObj = queryString.parse(props.location.search);
//   }

//   componentDidMount() {
//     const authToken = this.queryObj["authToken"];
//     const serviceCode = this.queryObj["serviceCode"];
//     if (serviceCode === "MONEYTREE") {
//       this.processInMoneytree(authToken);
//     } else if (serviceCode === "OKINV") {
//       this.processInMoneytree(authToken);
//     } else {
//       this.processInSyrup(authToken);
//     }
//   }

//   processInMoneytree(authToken) {
//     const accessToken = this.queryObj["accessToken"];
//     const name = this.queryObj["name"];
//     const serviceCode = this.queryObj["serviceCode"];
//     window.localStorage.setItem("accessToken", accessToken);
//     this.props.history.push({
//       pathname: "/main",
//       search: "?name=" + name + "&serviceCode=" + serviceCode,
//     });
//   }

//   processInSyrup(authToken) {
//     appendScript(process.env.REACT_APP_SYRUP_API, false);
//     const encKey = authToken.substr(0, 8);
//     setTimeout(() => {
//       API.signIn(authToken, (data) => {
//         window.localStorage.setItem("accessToken", data.data.token);
//         this.props.history.push({
//           pathname: "/ocbPw",
//           search: "?authToken=" + encKey + "&name=" + data.data.name,
//         });
//       });
//     }, 500);
//   }

//   render() {
//     return <Loader />;
//   }
// }

const Owp = (props) => {
  const [serviceCode_, setServiceCode] = useLocalStorage(
    STORAGE_KEY.SERVICE_CODE
  );
  const [accessToken_, setAccessToken] = useLocalStorage(
    STORAGE_KEY.ACCESS_TOKEN
  );
  const [accessSequence_, setAccessSequence] = useLocalStorage(
    STORAGE_KEY.ACCESS_SEQUENCE
  );

  const {
    accessToken,
    serviceCode,
    name,
    reason,
    sequence,
  } = queryString.parse(props.location.search);

  useEffect(() => {
    init();
  }, []);

  const init = () => {
    setServiceCode(serviceCode);
    setAccessToken(accessToken);
    if (sequence) {
      setAccessSequence(encodingBase64("" + sequence));
    }
    if (
      serviceCode === SERVICE_CODE.MONEYTREE ||
      serviceCode === SERVICE_CODE.OKINV
    ) {
      props.history.push({
        pathname: "/main",
        search: "?name=" + name + "&serviceCode=" + serviceCode,
      });
    } else if (serviceCode === SERVICE_CODE.HANA) {
      props.history.push(`hana-main?serviceCode=${serviceCode}`);
    } else if (reason) {
      props.history.push(`certification/error?reason=${reason}`);
    } else {
      appendScript(process.env.REACT_APP_SYRUP_API, false);
      const encKey = accessToken.substr(0, 8);
      setTimeout(() => {
        API.signIn(accessToken, (data) => {
          setAccessToken(data.data.token);
          props.history.push({
            pathname: "/ocbPw",
            search: "?authToken=" + encKey + "&name=" + data.data.name,
          });
        });
      }, 500);
    }
  };

  return <Loader />;
};

export default Owp;
